import { gql } from '@apollo/client'
import { Price } from '@jusbrasil-web/shared-price'

import { PlanFrequency } from '../../../../constants'
import { OfferCardPrice_OfferLockOfferFragment } from './__generated__/offer-card-price.graphql'

interface OfferCardPriceProps {
  offerLockOffer: OfferCardPrice_OfferLockOfferFragment
  className?: string
}

export const OfferCardPrice = ({ className, offerLockOffer }: OfferCardPriceProps) => {
  const { priceTitle, frequency, priceText, frequencyPeriodText, priceAfterPromotionalPeriodText } =
    offerLockOffer

  const isPromotional = !!priceAfterPromotionalPeriodText
  const isYearlyPlan = frequency === PlanFrequency.YEARLY

  const getPriceText = () => {
    if (isPromotional) {
      return (
        <>
          <Price.Value>{priceText}</Price.Value>
          <Price.Helptext>No {frequencyPeriodText}</Price.Helptext>
        </>
      )
    }

    return (
      <span>
        <Price.Value>{priceText}</Price.Value>
        {!isYearlyPlan && frequency && <Price.ValueFrequency>{frequency}</Price.ValueFrequency>}
      </span>
    )
  }

  return (
    <Price className={className}>
      {priceTitle && (
        <Price.Title>
          <span dangerouslySetInnerHTML={{ __html: priceTitle }} />
        </Price.Title>
      )}

      {getPriceText()}
    </Price>
  )
}

OfferCardPrice.fragments = {
  offerLockOffer: gql`
    fragment OfferCardPrice_offerLockOffer on OfferLockOffer {
      priceTitle
      priceText
      frequency
      frequencyPeriodText
      priceAfterPromotionalPeriodText
    }
  `,
}
